import '../../styles.css';

import React from 'react';
import { Select, SuggestInput, Button, Link, Typography } from '@vtblife/uikit';
import { Size, SuggestionOptions } from '@vtblife/uikit/legacy';
import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import { useLkLinks } from '@search/classified-common/src/SaveSearch/useLkLinks';
// @ts-ignore
import successLogo from '../../successPriceSubscribeImage.url.svg';
import Image from '../../../Image';
import { PersonalDataPolicy } from '../../../PersonalDataPolicy/PersonalDataPolicy';

const cn = classname.bind(null, 'SubscribeToPrice');

type Props = {
    offerId: string;
    isDisabledButton: boolean;
    hasSubscription?: boolean | null;
    isValidEmail: boolean;
    formType: 'desktop-snippet' | 'mobile1' | 'mobile2' | 'desktop-card';
    onSave: () => void;
    setEmail: (value: string) => Promise<boolean>;
    onEmailChange: (value: string | number) => void;
    selectedEmail: string;
    emailsSuggestions: SuggestionOptions[];
    nearPriceHistoryPlot?: boolean;
}

export const SubscribeToPriceForm = ({
    offerId,
    onSave,
    formType,
    isDisabledButton,
    hasSubscription: hasSubscriptionProp,
    selectedEmail,
    emailsSuggestions,
    isValidEmail,
    setEmail,
    onEmailChange,
    nearPriceHistoryPlot
}: Props) => {
    const { savedSearchUrl } = useLkLinks();
    const staticPath = useStaticPathConfig();

    const renderSubscribeForm = (suggestClassName: string, isMobile?: boolean) => {
        return (
            <>
                <Select mode='single' onChange={onEmailChange}>
                    <div className={cn(suggestClassName)}>
                        <SuggestInput
                            placeholder='Email'
                            onChange={setEmail}
                            value={selectedEmail}
                            debounce={100}
                            valid={isValidEmail}
                            size='s'
                        />
                    </div>
                    {emailsSuggestions.length > 0 && (
                        <Select.Content adaptivePlacement height='200px'>
                            {emailsSuggestions.map(data => (
                                <Select.Option value={data.value as string} key={data.label}>
                                    {data.value}
                                </Select.Option>
                            ))}
                        </Select.Content>
                    )}
                </Select>
                <Button
                    size={Size.Small}
                    disabled={isDisabledButton}
                    fullWidth={isMobile}
                    onClick={onSave}
                >
                    Следить
                </Button>
            </>
        );
    };

    const renderSuccessMessage = (className: string) => (
        <>
            <p className={cn(className)}>
                Мы&nbsp;сообщим вам, если цена изменится. Управлять уведомлениями можно в
                &nbsp;разделе <Link
                    variant='primary-minor'
                    href={savedSearchUrl}
                    target='blank'
                >
                    &laquo;Подписки&raquo;
                </Link>
            </p>
            <Image url={`${staticPath}${successLogo}`} />
        </>
    );

    const hasSubscription = sessionStorage.getItem(offerId) || hasSubscriptionProp;

    switch (formType) {
        case 'desktop-snippet': {
            return (
                <div className={cn(null, { nearPriceHistoryPlot })}>
                    {hasSubscription ? (
                        <div className={cn('subscription-success')}>
                            {renderSuccessMessage('subscription-message')}
                        </div>
                    ) : (
                        <div className={cn('desktop-subscribe-to-price')}>
                            <Typography variant='primary-alone' bold>
                                Следите за&nbsp;изменением цены&nbsp;в&nbsp;объявлении
                            </Typography>
                            <div className={cn('wrap')}>
                                {renderSubscribeForm('email-input-desktop')}
                            </div>
                            <PersonalDataPolicy />
                        </div>
                    )}
                </div>
            );
        }
        case 'desktop-card': {
            return (<>
                {hasSubscription ? null : (
                    <div>
                        <Typography variant='primary-alone' bold>
                            Мы сообщим вам, если цена изменится
                        </Typography>
                        <div className={cn('wrap')}>
                            {renderSubscribeForm('email-input-desktop')}
                        </div>
                        <PersonalDataPolicy />
                    </div>
                )}
            </>);
        }
        case 'mobile1':
        case 'mobile2': {
            return (
                <>
                    {hasSubscription ? (
                        <div className={cn('subscription-success-mobile')}>
                            {renderSuccessMessage('subscription-message-mobile')}
                        </div>
                    ) : (
                        <div className={cn('mobile', { withoutPaddingTop: formType !== 'mobile2' })}>
                            {formType === 'mobile2' ? (
                                <Typography variant='primary-alone' bold>
                                    Следите за&nbsp;изменением цены&nbsp;в&nbsp;объявлении
                                </Typography>
                            ) : null}
                            <div>{renderSubscribeForm('mobile-input', true)}</div>
                            <PersonalDataPolicy isMobile />
                        </div>
                    )}
                </>
            );
        }
        default:
            return null;
    }
};
